export const LocalStorageItems = {
    TOKEN: "token",
    MEMBER_DETAILS: 'memberDetails'
}

export const AppRoutes = {
    ORGANIZATION: {
        LOGIN: "/login",
        HOME: "/dashboard",
        DASHBOARD: "/dashboard",
        SETTINGS: "/settings",
        DONATIONS: {
            LIST: "/donations",
            UPDATE: (slug: string) => `/donations/edit/${slug}`,
            ADD: `/donations/add`,
        },
        USER_SETTINGS: "/user-settings",
        CITIES: "/cities",
        ORG_MEMBER: "/organization-member",
        NGOS: "/ngos",
        REPORT: "/report",
        MY_DONATION: "/my-donation",
        NGO: {
            ADD: "/ngo/add",
            UPDATE: (slug: string) => `/ngo/edit/${slug}`
        },
        CAMPAIGN: {
            LIST: `/campaign`,
            ADD: "/campaign/add",
            UPDATE: (slug: string) => `/campaign/edit/${slug}`
        },
        PROJECTS: {
            LIST: `/projects`,
        },
        RESET_PASSWORD: "/reset-password"
    },
    APP: {
        HOME: "/",
        LOGIN: "/login"
    },
    DONOR: {
        DONATION: "/donate",
        DONATION_NGO: "/donate/ngo",
        DONOR_LOGIN: "/login/donor",
        DONOR_REGISTER: "/register/donor",
        DONOR_VERIFY: "/verify/donor",
    },
    NGO: {
        HOME: (slug: string) => `/${slug}`,
        DONATE: (slug: string) => `/${slug}/donate`,
        SUMMARY: (slug: string) => `/${slug}/donate/summary`
    },
    ADMIN: {
        HOME: "/dashboard",
        ORGANIZATIONS: {
            LIST: "/organizations",
            ADD: "/organizations/add",
            UPDATE: (slug: string) => `/organizations/update/${slug}`
        },
        CAMPAIGN: {
            LIST: "/campaign",
            ADD: "/campaign/add",
            UPDATE: (slug: string) => `/campaign/update/${slug}`
        },
        CITY: {
            LIST: "/cities"
        },
        NGO: {
            LIST: "/ngos",
            ADD: "/ngo/add",
            UPDATE: (slug: string) => `/ngo/edit/${slug}`
        },
        CATEGORY: "/categories"
    },
    MEMBER: {
        HOME: "/members",
        ADD: "/members/add",
        EDIT: "/members/edit",
    }
}

export const ApiRoutes = {
    ADMIN: {
        GET_ORGANIZATIONS: "/admin/organizations",
        UPDATE_ORGANIZATION: (slug: string) => `/admin/organization/${slug}`,
        CREATE_ORGANIZATION: "/admin/organization",
        GET_ORGANIZATION: (slug: string) => `/admin/organization/${slug}`,
        CREATE_CITY: "/admin/city",
        GET_CITIES: "/admin/city",
        UPDATE_CITY: (slug: string) => `/admin/city/${slug}`,
        DELETE_CITY: (slug: string) => `/admin/city/${slug}`,

        NGO: {
            LIST: "/admin/ngo",
            CREATE: "/admin/ngo",
            UPDATE: (slug: string) => `/admin/ngo/${slug}`,
            DELETE: (slug: string) => `/admin/ngo/${slug}`,
            ADD_PROJECT: "/project",
            UPDATE_PROJECT: (slug: string) => `/project/${slug}`,
            DELETE_PROJECT: "/",
        }
    },
    ORGANIZATION: {
        CITY: {
            ADD_CUSTOM_CITY: "/city/custom-city",
            UPDATE_CUSTOM_CITY: (slug: string) => `/city/custom-city/${slug}`
        }
    }
}